(() => {
  const wrappedRequests = new WeakSet();

  const enableLiveCartErrorModal = () => {
    const cart = window.Rebuy?.Cart;

    if (!cart?.processQueue || cart.processQueue.hasLiveErrorModal) return;

    const originalProcessQueue = cart.processQueue;

    const processQueueWithLiveErrorModal = function (callback) {
      this.queue?.forEach((request) => {
        if (!request?.params || wrappedRequests.has(request)) return;

        const originalError = request.params.error;

        request.params.error = (error) => {
          if (typeof originalError === "function") originalError(error);

          const response = error?.cause?.res;
          if (!response) return;

          const title = response.message || "Cart Error";
          const message =
            response.description && response.description !== title
              ? response.description
              : null;

          window.Rebuy?.Modal?.dialog("dialog", {
            title,
            message,
            buttons: [{ type: "primary", label: "Okay", action: "dismiss" }],
          });
        };

        wrappedRequests.add(request);
      });

      return originalProcessQueue.call(this, callback);
    };

    processQueueWithLiveErrorModal.hasLiveErrorModal = true;
    cart.processQueue = processQueueWithLiveErrorModal;
  };

  document.addEventListener("rebuy:cart.ready", enableLiveCartErrorModal, {
    once: true,
  });
  enableLiveCartErrorModal();
})();
